import { contentItemAction } from '../../actions/contentItemActions';
import { menuAction } from '../../actions/menuActions';
import { trackingAction } from './student/tracking/itemsTrackingActions';
import { List, Stack } from 'immutable';

export interface HistoryItem {
  contentItemId: string;
  sectionId: string | null;
}

export interface CurrentSequencedFlowPositionState {
  current: string | null;
  currentSection: string | null;
  history: Stack<HistoryItem>;
  displayed: boolean;
  structure: List<HistoryItem>;
}

const emptyState = {
  current: null,
  currentSection: null,
  history: Stack<HistoryItem>(),
  displayed: false,
  structure: List<HistoryItem>(),
};

export function currentSequencedFlowPositionReducer(
  state: CurrentSequencedFlowPositionState = emptyState,
  action: any
): CurrentSequencedFlowPositionState {
  switch (action.type) {
    case menuAction.SideMenu_SelectSequencedFlowItem:
      if (action.payload.selectedItem.contentItems.isEmpty()) {
        return {
          currentSection: null,
          current: null,
          history: Stack<HistoryItem>(),
          displayed: false,
          structure: List<HistoryItem>(),
        };
      }
      return {
        currentSection: null,
        current: action.payload.selectedItem.contentItems.first(),
        history: Stack<HistoryItem>(),
        displayed: false,
        structure: action.payload.sequencedFlowStructure,
      };
    case contentItemAction.SequencedContent_GoToNext_Selected:
      return {
        ...state,
        current: action.payload.id,
        history: state.current
          ? state.history.push({ contentItemId: state.current, sectionId: state.currentSection })
          : state.history,
        displayed: false,
      };
    case contentItemAction.SequencedContent_GoToSection_Selected:
      return {
        ...state,
        currentSection: action.payload.id,
        current: action.payload.children.first(),
        history: state.current
          ? state.history.push({ contentItemId: state.current, sectionId: state.currentSection })
          : state.history,
      };
    case contentItemAction.SequencedContent_GoTo_Selected:
      return {
        ...state,
        currentSection: action.payload.sectionContentItemId,
        current: action.payload.contentItemId,
        history: action.payload.history,
        displayed: false,
      };
    case contentItemAction.SequencedContent_Display:
      return {
        ...state,
        displayed: true,
      };
    case contentItemAction.SequencedContent_GoToPrevious_Selected: {
      return {
        ...state,
        current: state.history.peek()?.contentItemId ?? null,
        currentSection: state.history.peek()?.sectionId ?? null,
        history: state.history.pop(),
        displayed: false,
      };
    }

    case contentItemAction.SequencedContent_Dismiss: {
      return {
        ...state,
        displayed: false,
      };
    }
    case contentItemAction.SequencedContent_Finish_Selected:
    case menuAction.SideMenu_DeselectItem:
    case menuAction.SideMenu_NavigateBack:
    case menuAction.SideMenu_SelectedSubmenuItem:
    case menuAction.SideMenu_SelectNonSequencedFlowItem:
    case menuAction.SideMenu_SelectedQuiz:
    case menuAction.SideMenu_SelectedResource:
    case trackingAction.Tracking_ResetProgress:
      return emptyState;
    default:
      return state;
  }
}
